import { jsx as _jsx } from "react/jsx-runtime";
import s from './SidebarItem.module.scss';
export const SidebarItem = ({ children, color = 'grey', onClick }) => (_jsx("div", { className: s.item, onClick: onClick, style: { backgroundColor: `${color === 'blue' ? '#007AFF' : 'rgb(var(--background-tertiary))'}` }, children: children }));
